import axiosInstance from "../libs/axiosInstance";

export const uploadProfilePicture = async (file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const response = await axiosInstance.post("account/upload-profile-pic/", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("Error uploading profile picture:", error);
    throw error;
  }
};

export const removeProfilePicture = async () => {
  try {
    const response = await axiosInstance.delete("account/remove-profile-pic/");
    return response.data;
  } catch (error) {
    console.error("Error removing profile picture:", error);
    throw error;
  }
};


/**
 * Update Password
 * POST /account/update-password/
 * payload = { old_password, new_password }
 */
export const updatePassword = async (payload) => {
  try {
    const response = await axiosInstance.post("account/update-password/", payload);
    return response.data;
  } catch (error) {
    console.error("Error updating password:", error);
    throw error;
  }
};

/**
 * Fetch users with pagination, user type, date joined range/exact, and ordering filters
 * GET /account/admin/users/most-active/
 * @param {number} page
 * @param {Object} filters - { type, date_joined, start_date, end_date, order_by }
 */
export const getMostActiveUsers = async (page = 1, filters = {}) => {
  try {
    const params = { page, ...filters };
    // Remove empty, null, or undefined keys
    Object.keys(params).forEach((key) => {
      if (params[key] === "" || params[key] === null || params[key] === undefined) {
        delete params[key];
      }
    });

    const response = await axiosInstance.get("account/admin/users/most-active/", { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching most active users:", error);
    throw error;
  }
};

/**
 * Search for users by query string
 * GET /account/admin/users/search/?q=<term>
 */
export const searchUsers = async (query) => {
  try {
    const response = await axiosInstance.get("account/admin/users/search/", {
      params: { q: query },
    });
    return response.data;
  } catch (error) {
    console.error("Error searching users:", error);
    throw error;
  }
};

/**
 * Toggle a user’s active status
 * POST /account/admin/users/<uuid:pk>/toggle_active/
 */
export const toggleUserActiveStatus = async (userId) => {
  try {
    const response = await axiosInstance.patch(`account/admin/users/${userId}/toggle_active/`);
    return response.data;
  } catch (error) {
    console.error(`Error toggling user ${userId} active status:`, error);
    throw error;
  }
};

/**
 * Verify OTP sent to user email
 * POST /account/verify-otp/
 * payload = { email, otp }
 */
export const verifyOtp = async (payload) => {
  try {
    const response = await axiosInstance.post("account/verify-otp/", payload);
    return response.data;
  } catch (error) {
    console.error("Error verifying OTP:", error);
    throw error;
  }
};

/**
 * Resend OTP to user email
 * POST /account/resend-otp/
 * payload = { email }
 */
export const resendOtp = async (email) => {
  try {
    const response = await axiosInstance.post("account/resend-otp/", { email });
    return response.data;
  } catch (error) {
    console.error("Error resending OTP:", error);
    throw error;
  }
};

/**
 * Upload Student ID Card
 * PATCH /account/students/<profile_id>/
 * payload = FormData containing student_id_card
 */
export const uploadStudentIDCard = async (profileId, file) => {
  try {
    const formData = new FormData();
    formData.append("student_id_card", file);

    const response = await axiosInstance.patch(`/account/students/${profileId}/`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 2 * 60 * 1000, // 2 minutes timeout for face verification
    });
    return response.data;
  } catch (error) {
    console.error("Error uploading student ID card:", error);
    throw error;
  }
};

/**
 * Submit student ID card for background verification
 * POST /account/student/id-submissions/
 * payload = FormData containing id_card_image
 */
export const submitStudentIDCard = async (file) => {
  try {
    const formData = new FormData();
    formData.append("id_card_image", file);

    const response = await axiosInstance.post("/account/student/id-submissions/", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    console.error("Error submitting student ID card:", error);
    throw error;
  }
};

/**
 * Check the status of a student ID verification submission
 * GET /account/student/id-submissions/<submission_id>/
 */
export const getStudentIDSubmissionStatus = async (submissionId) => {
  try {
    const response = await axiosInstance.get(`/account/student/id-submissions/${submissionId}/`);
    return response.data;
  } catch (error) {
    console.error(`Error checking student ID submission ${submissionId} status:`, error);
    throw error;
  }
};

/**
 * Get history of student ID card submissions
 * GET /account/student/id-submissions/
 */
export const getStudentIDSubmissionsHistory = async () => {
  try {
    const response = await axiosInstance.get("/account/student/id-submissions/");
    return response.data;
  } catch (error) {
    console.error("Error fetching student ID submissions history:", error);
    throw error;
  }
};

/**
 * Fetch OTP login settings for the current user
 * GET /account/settings/otp/
 */
export const getOtpSettings = async () => {
  try {
    const response = await axiosInstance.get("/account/settings/otp/");
    return response.data;
  } catch (error) {
    console.error("Error fetching OTP settings:", error);
    throw error;
  }
};

/**
 * Update OTP login settings for the current user
 * PATCH /account/settings/otp/
 * payload = { otp_enabled: boolean }
 */
export const updateOtpSettings = async (payload) => {
  try {
    const response = await axiosInstance.patch("/account/settings/otp/", payload);
    return response.data;
  } catch (error) {
    console.error("Error updating OTP settings:", error);
    throw error;
  }
};



